import React, { useEffect, useState } from "react";
import { SECTION_META, CUSTOM_BENCHMARK_STORAGE_KEY } from "../../constants/benchmarkTypes";

function loadCustomGroups() {
  try {
    const raw = localStorage.getItem(CUSTOM_BENCHMARK_STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function saveCustomGroups(groups) {
  localStorage.setItem(CUSTOM_BENCHMARK_STORAGE_KEY, JSON.stringify(groups));
}

export default function CustomBenchmarkPanel({ onApply, activeGroupId }) {
  const [groups, setGroups] = useState(loadCustomGroups);
  const [name, setName] = useState("");
  const [sectionTargets, setSectionTargets] = useState(
    Object.fromEntries(SECTION_META.map((s) => [s.key, 65])),
  );

  useEffect(() => {
    if (activeGroupId) {
      const group = groups.find((g) => g.id === activeGroupId);
      if (group?.sections) setSectionTargets(group.sections);
    }
  }, [activeGroupId, groups]);

  const handleSave = () => {
    if (!name.trim()) return;
    const entry = {
      id: `custom-${Date.now()}`,
      name: name.trim(),
      sections: { ...sectionTargets, overall: sectionTargets.base },
      createdAt: new Date().toISOString(),
    };
    const next = [...groups, entry];
    setGroups(next);
    saveCustomGroups(next);
    setName("");
    onApply?.(entry.sections);
  };

  const handleSelect = (group) => {
    onApply?.(group.sections);
  };

  const handleDelete = (id) => {
    const next = groups.filter((g) => g.id !== id);
    setGroups(next);
    saveCustomGroups(next);
  };

  return (
    <div className="benchmark-panel">
      <h2>Custom benchmark groups</h2>
      <p style={{ fontSize: "0.8rem", color: "#6b7280", margin: "0 0 1rem" }}>
        Define target section scores for stakeholder groups, investor requirements, or internal goals.
      </p>

      <div className="custom-benchmark-form">
        {SECTION_META.map((s) => (
          <label key={s.key}>
            {s.label} target
            <input
              type="number"
              min={0}
              max={100}
              value={sectionTargets[s.key]}
              onChange={(e) =>
                setSectionTargets((prev) => ({
                  ...prev,
                  [s.key]: Number(e.target.value),
                }))
              }
            />
          </label>
        ))}
      </div>

      <div style={{ display: "flex", gap: "0.5rem", marginTop: "1rem", flexWrap: "wrap" }}>
        <input
          type="text"
          placeholder="Group name (e.g. Investor 2026 targets)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={{
            flex: 1,
            minWidth: 200,
            padding: "0.5rem 0.65rem",
            border: "1px solid #e5e7eb",
            borderRadius: 6,
            fontSize: "0.85rem",
          }}
        />
        <button
          type="button"
          onClick={handleSave}
          style={{
            padding: "0.5rem 1rem",
            background: "#02b880",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
            fontSize: "0.85rem",
          }}
        >
          Save group
        </button>
      </div>

      {groups.length > 0 && (
        <ul style={{ marginTop: "1.25rem", padding: 0, listStyle: "none" }}>
          {groups.map((g) => (
            <li
              key={g.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0.5rem 0",
                borderBottom: "1px solid #f3f4f6",
                fontSize: "0.85rem",
              }}
            >
              <button
                type="button"
                onClick={() => handleSelect(g)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#02b880",
                  cursor: "pointer",
                  fontWeight: 600,
                  padding: 0,
                }}
              >
                {g.name}
              </button>
              <button
                type="button"
                onClick={() => handleDelete(g.id)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#dc2626",
                  cursor: "pointer",
                  fontSize: "0.75rem",
                }}
              >
                Remove
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
